// eslint-disable-next-line import/prefer-default-export
export const MODULE_NS = 'scaifeReader';
export const SELECT_TOKEN = 'readerSelectToken';
export const CLEAR_TOKEN = 'readerClearToken';
